import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import { logout } from "../Login/auth";
import AuthContext from "../../AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faLock, faUsers, faBook } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@mui/material/CircularProgress';
function Dashboard() {
  const { user, loading } = useContext(AuthContext);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/login");
    setName(user.displayName || user.email || "");
  }, [user, loading, navigate]);


  if (loading) {
    return (
      <div className="dashboard">
        <div className="dashboard__container" style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
       <div className="dashboard__container">
        <h1 style={{ color: '#ffffff', marginBottom: '20px' }}>Welcome to Home Dashboard</h1>
        
        <div style={{ marginBottom: '20px' }}>
          Logged in as
          <div style={{ color: '#ffffff', fontSize: '18px', fontWeight: 'bold' }}>
            {name}
          </div>
          <div style={{ color: '#cccccc' }}>{user?.email}</div>
        </div>

        <div className="dashboard__nav">
          <button 
            className="dashboard__nav-btn dashboard__nav-btn--shopping" 
            onClick={() => navigate('/shopping')}
          >
            <FontAwesomeIcon icon={faShoppingCart} />
            <span>Shopping Lists</span>
          </button>
          
          <button 
            className="dashboard__nav-btn dashboard__nav-btn--vault" 
            onClick={() => navigate('/vault')}
          >
            <FontAwesomeIcon icon={faLock} />
            <span>Vault</span>
          </button>
          
          <button 
            className="dashboard__nav-btn dashboard__nav-btn--users" 
            onClick={() => navigate('/users')}
          >
            <FontAwesomeIcon icon={faUsers} />
            <span>User Management</span>
          </button>

          <button 
            className="dashboard__nav-btn dashboard__nav-btn--recipes" 
            onClick={() => navigate('/recipes')}
          >
            <FontAwesomeIcon icon={faBook} />
            <span>Recipe Books</span>
          </button>
        </div>

         <button className="dashboard__btn" onClick={logout}>
          Logout
         </button>
       </div>
     </div>
  );
}
export default Dashboard;